/**
 * Validates if a string is a properly formatted email address.
 * Uses a regex pattern that checks for basic email format: localpart@domain.tld
 *
 * @param email - The email string to validate
 * @returns true if the email is valid, false otherwise
 */
export function isValidEmail(email: string): boolean {
  const emailRegex =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;
  return emailRegex.test(email.trim());
}

/**
 * Sanitizes an email input by trimming whitespace and converting to lowercase.
 *
 * @param input - The raw email input string
 * @returns The sanitized email address
 */
export function sanitizeEmailInput(input: string): string {
  return input.trim().toLowerCase();
}
